import { render } from "./DropdownTooltip.vue?vue&type=template&id=ac5683bc&ts=true"
import script from "./DropdownTooltip.vue?vue&type=script&lang=ts"
export * from "./DropdownTooltip.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__